<template>
  <div id="pageTable" class="subView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="">
              <v-form v-model="valid">
                <v-btn icon style="right:10px" @click="openDialogUsers">
                  <v-icon>search</v-icon>
                </v-btn>
                사용자 검색
                <v-dialog v-model="users.dialog" max-width="1000px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">사용자 조회</span>
                    </v-card-title>
                    <v-toolbar card color="white">
                      <div class="flex xs12 sm2">
                      <v-select
                        :items="[{
                                  text: '이름',
                                  value: 'name'
                                },
                                {
                                  text: '전화번호',
                                  value: 'phoneNumber'
                                }]"
                        name="header"
                        v-model="searchUsersFormModel.filter"    
                        label="header"
                      ></v-select> 
                      </div>
                      <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchUsersFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchUserFilter"
                      ></v-text-field>
                      <v-btn icon @click="searchUserFilter">
                        <v-icon>filter_list</v-icon>
                      </v-btn> 
                    </v-toolbar>        
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-data-table
                        :headers="complex.headers"
                        :items="complex.items"
                        :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                        class="elevation-1"
                        item-key="userId"
                        must-sort
                        :total-items="totalItems"
                        :loading="loading"
                        :pagination.sync="pagination"
                        >
                        <template slot="items" slot-scope="props">                
                          <td class="text-sm-center" @dblclick="selectUser(props.item)">{{ props.item.userId }}</td>
                          <td class="text-sm-center" @dblclick="selectUser(props.item)">{{ props.item.userType == 'P' ? '승객' : '기사' }}</td>
                          <td class="text-sm-center" @dblclick="selectUser(props.item)">{{ props.item.phoneNumber }}</td>
                          <td class="text-sm-center" @dblclick="selectUser(props.item)">{{ props.item.name }}</td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer>
                      </v-spacer>
                      <v-btn color="blue darken-1" flat @click="closeDialogUsers">닫기</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-text-field
                  label="제목"
                  name="title"
                  v-model="formModel.title"
                  v-validate="'required'"
                  data-vv-name="title"     
                  :error-messages="errors.collect('title')"  
                  required
                ></v-text-field>
                <v-text-field
                  label="요청자이름"
                  name="requestUserName"
                  v-model="formModel.requestUserName"
                  v-validate="'required'"
                  data-vv-name="requestUserName"     
                  :error-messages="errors.collect('requestUserName')"  
                  required
                ></v-text-field>
                <v-text-field
                  label="요청자 전화번호"
                  name="requestUserPhoneNumber"
                  v-model="formModel.requestUserPhoneNumber"
                  v-validate="'required'"
                  data-vv-name="requestUserPhoneNumber"     
                  :error-messages="errors.collect('requestUserPhoneNumber')"  
                  required
                ></v-text-field> 
                <v-text-field
                  textarea
                  name="contents"
                  label="내용"
                  v-model="formModel.contents"
                  v-validate="'required'"
                  data-vv-name="contents"     
                  :error-messages="errors.collect('contents')"
                  required>
                </v-text-field>
                <div class="form-btn">
                  <v-btn outline @click="submit" color="primary">저장</v-btn>
                  <v-btn outline @click="cancel" color="primary">취소</v-btn>
                </div>
              </v-form>
            </v-card-text>       
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new'
  },    
  data () {
    return {
      remainCount: null,
      formModel: {
        title: '',
        requestUserName: '',
        contents: '',
        requestUserPhoneNumber: '',
        requestUserId: null,
        requestUserType: null,
      },
      searchUsersFormModel: {
        filter: 'name',
        filterText: ''
      },
      pagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      loading: true,
      totalItems: 0,
      prevData: null,
      users: {
        dialog: false
      },
      valid: true,
      complex: {
        headers: [
          {
            text: '사용자번호',
            value: 'userId',
            align: 'center'
          },
          {
            text: '사용자타입',
            value: 'userType',
            align: 'center'
          },
          {
            text: '전화번호',
            value: 'phoneNumber',
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  watch: {
    pagination: {
      handler () {
        this.searchUser();
      },
      deep: true
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.$validator.localize('en', this.dictionary);
  },  
  methods: {
    submit () {
      
      this.$validator.validateAll()
        .then((validate) => {
          if (validate) {
            const parameters = {
              method: 'createVOC',
              title: this.formModel.title,
              contents: this.formModel.contents,
              requestUserName: this.formModel.requestUserName,
              requestUserPhoneNumber: this.formModel.requestUserPhoneNumber,
              requestUserId: this.formModel.requestUserId,
              requestUserType: this.formModel.requestUserType
            };
            this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                top.getApp.progress.dialog = false;
                alert('등록되었습니다');
                this.$router.go(-1);
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
          }
       });;
    },
    cancel () {
      if (confirm('현재 작성중인 내용은 지워집니다.')) {
        this.$router.go(-1);
      }
    },
    openDialogUsers () {
      this.users.dialog = true;
      this.searchUser();
    },
    searchUser () {
      this.loading = true;

      const prameters = {
        method: 'searchUsers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchUsersFormModel.filter,
        filterText: this.searchUsersFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          this.prevData = data;
          this.nextSearchUser()
            .then(data => {
              this.complex.items = data.items;
              this.totalItems = data.total;
            });
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
          });
    },
    nextSearchUser () {
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination

        let items = this.prevData.content;
        const total = this.prevData.totalElements;

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        // if (rowsPerPage > 0) {
        //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        // }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    searchUserFilter () {
      this.searchUser();
    },
    closeDialogUsers () {
      this.users.dialog = false;
    },
    selectUser (item) {
      this.formModel.requestUserId = item.userId;
      this.formModel.requestUserType = item.userType;
      this.formModel.requestUserName = item.name;
      this.formModel.requestUserPhoneNumber = item.phoneNumber;
      alert(item.name + '님이 선택되었습니다.');
      this.users.dialog = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/voc/CreateVOC.vue